import Heading from 'atoms/Heading';
import Text from 'atoms/Text';
import React from 'react'
import { X } from 'react-feather';

const MainSideBar = ({ heading, children, showSidebar, setShowSidebar, className, headClass, subHeading }) => {
    return (
        <div className={`${className} fixed right-12 ${showSidebar ? "translate-x-0" : "translate-x-[480px]"} transform transition-transform duration-300 ease-in-out top-0 z-[9999]`}>
            <div className='px-3 py-4 bg-primary-400 w-[432px] border-l border-gray-500 h-screen'>
                <div className={` pb-3 mb-3 border-b border-gray-500 ${headClass}`}>
                    <div className='flex items-center justify-between'>
                        <Heading type="h5" className="text-gray-100">{heading}</Heading>
                        <X size={24} className='text-gray-100 cursor-pointer' onClick={() => setShowSidebar(false)} />
                    </div>
                    {subHeading && <Text variant="caption" className="text-gray-200 mt-0.5">{subHeading}</Text>}
                </div>
                {children}
            </div>
        </div>
    )
}

export default MainSideBar
